import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { LayoutGrid, LayoutGridCell } from '@llt-frontend/react-material-layout-grid';

//

function ContentWithHeading({ children, className, heading }) {
  return (
    <LayoutGrid className={classNames('primary-grid', className)}>
      {heading && (
        <LayoutGridCell>
          <h2 className="primary-grid__heading">{heading}</h2>
        </LayoutGridCell>
      )}

      <LayoutGridCell>{children}</LayoutGridCell>
    </LayoutGrid>
  );
}

ContentWithHeading.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  heading: PropTypes.node,
};

// Exports
// -------

export default ContentWithHeading;
